import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';

const AnalyticsComponent = lazy(() => import('./analytics.tsx'));
const AnalyticsOrdersComponent = lazy(
  () => import('./pages/analytics-orders/analytics-orders.tsx')
);
const AnalyticsServicesComponent = lazy(
  () => import('./pages/analytics-services/analytics-services.tsx')
);
const AnalyticsGuestsComponent = lazy(
  () => import('./pages/analytics-guests/analytics-guests.tsx')
);
const AnalyticsPlatformsComponent = lazy(
  () => import('./pages/analytics-platforms/analytics-platforms.tsx')
);
const AiConciergeComponent = lazy(
  () => import('./pages/ai-concierge/ai-concierge.tsx')
);

export const analyticsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <AnalyticsComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.Analytics.Orders.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.Analytics.Orders.path,
        element: (
          <Suspense>
            <AnalyticsOrdersComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Analytics.Services.path,
        element: (
          <Suspense>
            <AnalyticsServicesComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Analytics.Guests.path,
        element: (
          <Suspense>
            <AnalyticsGuestsComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Analytics.Platforms.path,
        element: (
          <Suspense>
            <AnalyticsPlatformsComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Analytics.AiConcierge.path,
        element: (
          <Suspense>
            <AiConciergeComponent />
          </Suspense>
        )
      }
    ]
  }
];
